var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFlatSecondary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "M14 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1h-5zM5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v2H5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FEFEFE",
  d: "M15 4.5h3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FEFEFE",
  strokeWidth: 4,
  d: "M6 5h1"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M16 8h1M7 8h1m3.5 0h1m3.5 3h1M7 11h1m3.5 0h1m3.5 3h1m-1 3h1M7 14h1m-1 3h1m3.5-3h1"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4 6v15M20 6v15"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 5,
  x: 10,
  y: 17,
  fill: "#2F1F19",
  rx: 1
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FEFEFE",
  d: "M11 19.5h2"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FEFEFE",
  strokeWidth: 3,
  d: "M11 19.5h2"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M2.75 21.25h18.5M3.5 5.25h17"
})));
export default SvgIconFlatSecondary;